<template>
  <section id="print">
    <div class="rowVar">
      <ul>
        <template v-for="(variety, index) in varieties">
          <template v-if="$route.query.quantity">
            <li
              class="variety"
              v-for="q in +$route.query.quantity"
              :key="q * index + index"
            >
              <input type="text" v-model="productName" class="varietyPrice" />

              <barcode
                class="varietyBarcode"
                fontSize="12"
                width="1"
                marginBottom="0"
                height="20"
                :value="variety[0]"
                :text="variety[4]"
              >
                {{ variety[0] }}
              </barcode>
              <span class="priceName">
                {{ variety[2] }}
              </span>
              <span class="varName">
                {{ variety[0] }}
              </span>
            </li>
          </template>
          <template v-else>
            <li
              class="variety"
              v-for="q in variety[3]"
              :key="q * index + index"
            >
              <input type="text" v-model="productName" class="varietyPrice" />

              <barcode
                class="varietyBarcode"
                fontSize="12"
                width="1"
                marginBottom="0"
                height="20"
                :value="variety[0]"
                :text="variety[4]"
              >
                {{ variety[0] }}
              </barcode>
              <span class="priceName">
                {{ variety[2] }}
              </span>
              <span class="varName">
                {{ variety[0] }}
              </span>
            </li>
          </template>
        </template>
      </ul>
    </div>
    <button id="printBtn" @click="print">پرینت</button>
  </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/printVarieties/printVarietiesImpl";
export default {
  extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
